export default __webpack_public_path__ + "static/media/400.c0e8abe0.png";